export function toPairs(object) {
    return Object.entries(object);
}
(function (toPairs) {
    function strict(object) {
        return Object.entries(object);
    }
    toPairs.strict = strict;
})(toPairs || (toPairs = {}));
